const ModalTypes = {
  SERVER_CREATE: 3,
  SERVER_JOIN: 4,
  IMPORT:5,
  CUSTOM:55,
};

class ModalManager {
  constructor() {
    this.modalStateManager = null;
  }
  register(modalStateManager) {
    this.modalStateManager = modalStateManager;
  }
  showModal(type, data) {
    if (this.modalStateManager) this.modalStateManager(type, data);
  }
  closeModal() {
    if (this.modalStateManager) this.modalStateManager(null);
  }
}

const ModalService = new ModalManager();

export { ModalService, ModalTypes };
